module.exports = __webpack_public_path__ + "img/name_on.9bd5ffda.png";